/**
 * Default language supported by all i18n providers.
 */
export const defaultLanguage = "en";
